export class DeviceViewportDetection {

    /**
     * Get viewport width.
     */
    public get width() {
        return window.innerWidth;
    }

    /**
     * Get viewport height.
     */
    public get height() {
        return window.innerHeight;
    }

    /**
     * Get screen height.
     */
    public get screenHeight() {
        return window.screen.height;
    }

    /**
     * Get screen width.
     */
    public get screenWidth() {
        return window.screen.width;
    }

    /**
     * Get the pixel ratio for the current running device.
     */
    public get pixelRatio() {
        var ratio = 1;

        const screen = window.screen as any;

        // To account for zoom, change to use deviceXDPI instead of systemXDPI
        if (screen.systemXDPI !== undefined && screen.logicalXDPI !== undefined && screen.systemXDPI > screen.logicalXDPI) {
            // Only allow for values > 1
            ratio = screen.systemXDPI / screen.logicalXDPI;
        } else if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        }
        return ratio;
    }

    public get isPortrait() {
        return window.matchMedia("(orientation: portrait)").matches;
    }
}